import { memo, useCallback } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { Button } from "@design-system/Button/Button";
import { RightArrowIcon } from "@icons";
import tableStyles from "@design-system/ViewTable/ViewTable.module.scss";
import classNames from "classnames";
import { HistoryRow } from "../historyViewConfig";
import { HistoryTableMeta } from "../../History";
import { isTinAccessRow } from "../../utils/getActivityDescription";
import styles from "./Cell.module.scss";

export const ActionsCell = memo(
    ({ row, table }: CellContext<ViewTableFeatures, HistoryRow, unknown>) => {
        const meta = table.options.meta as HistoryTableMeta | undefined;

        const handleView = useCallback(() => {
            meta?.callbacks?.onViewDetails(row.original);
        }, [meta, row.original]);

        if (isTinAccessRow(row.original)) {
            return <ViewTableCell className={styles.actions} />;
        }

        return (
            <ViewTableCell className={styles.actions} captureClicks>
                <Button
                    variant="primary"
                    size="md"
                    onClick={handleView}
                    title="View details"
                    aria-label="View details"
                    className={classNames(
                        styles.viewDetailsButton,
                        tableStyles.showOnHover,
                    )}
                    rightIcon={<RightArrowIcon />}
                >
                    <span className={styles.viewDetailsButtonText}>View</span>
                </Button>
            </ViewTableCell>
        );
    },
);

ActionsCell.displayName = "ActionsCell";
